import FileDownload from "js-file-download"

import { ErrorsActions } from "../Redux/redux/errors.slice"

/**
 * Resolves a human-readable error message from an apisauce response.
 * Requests using `responseType: 'blob'` (file downloads) still get JSON error
 * bodies, but apisauce hands them back as a Blob — re-parse it as JSON first.
 */
export const getApiErrorMessage = async (response) => {
  let data = response.data
  if (data instanceof Blob) {
    data = JSON.parse(await data.text())
  }
  const detail = Array.isArray(data?.detail) ? data.detail[0] : data?.detail
  return data?.message?.detail || data?.message || detail
}

/**
 * Dispatches the shared error notification for a failed response.
 * Skip calling this (was `withoutErrorNotification`) when a thunk shouldn't
 * show the global notification.
 */
export const handleApiError = async (dispatch, response) => {
  const errorMessage = await getApiErrorMessage(response)
  dispatch(
    ErrorsActions.errorSave(response.status === 500 ? "Server response error" : errorMessage)
  )
}

/**
 * Triggers a browser download for a file response, deriving the filename from
 * the Content-Disposition header when present.
 */
export const downloadFileFromResponse = (response, fallbackName) => {
  const disposition = response?.headers?.["content-disposition"]
  let fileName = fallbackName
  if (disposition && disposition.includes("filename=")) {
    fileName = disposition.split("filename=")[1].split(";")[0].replace(/['"]/g, "")
  }
  FileDownload(response.data, fileName)
}
